module.exports = __webpack_public_path__ + "static/img/16areaB_3.680990f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/16areaB_3.png
// module id = 1132
// module chunks = 1